module.exports = __webpack_public_path__ + "static/img/p3.f7787e8b.png";